import * as React from "react"
import {Helmet} from 'react-helmet'

//components
import Layout from '../components/layout/'
import CarruselPrincipal from '../components/carrusel'
import GridImagenes from '../components/imagenes/GridImagenes'
import FormularioContacto from '../components/formulario'
import Mapa from '../components/mapa'
import Ubicacion from '../components/ubicacion/Ubicacion'

const IndexPage = () => {
  const carruselUno = [
    {
        imagen : 'Home/Slider/1_slider/cabo-marques-acapulco-guerero.jpg',
        imagenMovil : 'Home/Slider/1_slider/JPEG/cabo-marques-acapulco-guerero.jpg',
        descripcion: '250 HECTÁREAS EN FRACCIONAMIENTO PRIVADO',
        titulo: 'Cabo Marqués, Acapulco Diamante',
        video: 'https://vimeo.com/566670146',
        direccion: 'izquierda',
    },
    {
        imagen : 'Home/Slider/2_slider/macrolotes-cabo-marques.jpg',
        imagenMovil : 'Home/Slider/2_slider/JPEG/macrolotes-cabo-marques.jpg',
        descripcion: 'DESARROLLO PARA HOTELES, RESIDENCIAS, DEPARTAMENTOS Y CENTROS COMERCIALES',
        titulo : 'Macrolotes, Cabo Marqués',
        direccion: 'izquierda',
        enlace: '/proyectos/macrolotes'
    },
    {
      imagen : 'Home/Slider/1_slider/acceso-cabo-marques.jpg',
      imagenMovil : 'Home/Slider/1_slider/JPEG/acceso-cabo-marques.jpg',
      descripcion: 'AMBIENTE EN PRIVACIDAD Y EXCLUSIVIDAD',
      titulo: 'Cabo Marqués, Acapulco Diamante',
      direccion: 'izquierda',
    },
    {
      imagen : 'Home/Slider/2_slider/los-riscos-cabo-marques.jpg',
      imagenMovil : 'Home/Slider/2_slider/JPEG/los-riscos-cabo-marques.jpg',
      descripcion: '21 HECTAREAS  CON INQUEBRANTABLE RESPETO A LA NATURALEZA',
      titulo : 'Fraccionamiento Los Riscos, Cabo Marqués',
      direccion: 'izquierda',
      enlace: '/proyectos/los-riscos'
    },
    {
      imagen : 'Home/Slider/1_slider/helipuerto-cabo-marques.jpg',
      imagenMovil : 'Home/Slider/1_slider/JPEG/helipuerto-cabo-marques.jpg',
      descripcion: 'ACCESOS VIA TERRESTRE, NÁUTICA Y AÉREA',
      titulo: 'Cabo Marqués, Acapulco Diamante',
      direccion: 'izquierda',
    },
    {
      imagen : 'Home/Slider/2_slider/banyan-tree-cabo-marques.jpg',
      imagenMovil : 'Home/Slider/2_slider/JPEG/banyan-tree-cabo-marques.jpg',
      descripcion: 'HOTEL CINCO DIAMANTES Y RESTAURANTES DE CLASE MUNDIAL',
      titulo : 'Banyan Tree, Cabo Marqués',
      direccion: 'izquierda',
      enlace: '/proyectos/banyan-tree'
    },
    {
      imagen : 'Home/Slider/1_slider/vialidades-cabo-marques.jpg',
      imagenMovil : 'Home/Slider/1_slider/JPEG/vialidades-cabo-marques.jpg',
      descripcion: '100% URBANIZADO, CONDOMINIOS Y SERVICIOS OPERANDO',
      titulo: 'Cabo Marqués, Acapulco Diamante',
      direccion: 'izquierda',
    },
    {
        imagen : 'Home/Slider/2_slider/marina-cabo-marques.jpg',
        imagenMovil : 'Home/Slider/2_slider/JPEG/marina-cabo-marques.jpg',
        descripcion: 'LA ÚNICA MARINA EN ACAPULCO DIAMANTE',
        titulo : 'Marina Cabo Marqués, Acapulco Diamante',
        direccion: 'izquierda',
        enlace: '/proyectos/marina-cabo-marques'
    },
    {
      imagen : 'Home/Slider/1_slider/club-de-playa-de-suka-y-sal.jpg',
      imagenMovil : 'Home/Slider/1_slider/JPEG/club-de-playa-de-suka-y-sal.jpg',
      descripcion: 'ACCESO A DOS PLAYAS DESDE EL FRACCIONAMIENTO',
      titulo: 'Cabo Marqués, Acapulco Diamante',
      direccion: 'izquierda',
    },
  ]

  return (
    <>
      <Layout>
        <Helmet defer={false}>
          <meta charSet="utf-8" />
          <title>Cabo Marqués, Acapulco Diamante</title>
          <meta name="description" content="250 HECTÁREAS EN FRACCIONAMIENTO PRIVADO" />
        </Helmet>
        <CarruselPrincipal direccion="izquierda" imgs={carruselUno}/>
        <Mapa />
        <GridImagenes />
        <Ubicacion />
        <FormularioContacto />
      </Layout>
    </>
  )
}

export default IndexPage
